import React from 'react';

export const GAME = 'game';
export const WEB = 'web';

export const tagList = [GAME, WEB];

import Videomgame from '../images/videogame.svg';
import World from '../images/world.svg';

export const tagIcons = {
  [GAME]: <Videomgame />,
  [WEB]: <World />,
};